//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { useEffect } from 'react';
import OrdersTitleBar from './OrdersBar/OrdersTitleBar';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import TableContainer from '@/components/_common/Table/TableContainer';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const Orders = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('orders'));
  }, []);

  return (
    <>
      {currentTableKey === 'orders' && (
        <>
          <OrdersTitleBar />
          <DataTableFilters />
          <TableContainer />
        </>
      )}
    </>
  );
};

export default Orders;
